import React from 'react';
import {
  Image,
  ScrollView,
  StyleSheet,
  Text,
  TextInput,
  View,
} from '../base_components';
import BusyComponent from '../busy_component';
import uuidv4 from 'uuid/v4';

import CoinPrice from '../coin_price';
import CloseButton from '../buttons/close_button';
import WideButton from '../buttons/wide_button';
import ModalDialog from '../dialogs/modal_dialog';
import { Prize } from '../../data/prizes';

import ItemStore from '../../stores/item_store';

const styles = StyleSheet.create({
  checkoutOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.9)',

    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  close: {
    position: 'absolute',
    top: '1em',
    right: '1em',
    height: '3em',
    width: '3em',
  },
  scroller: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  scrollInner: {
    width: '100%',

    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  titleWrapper: {
    marginTop: '3em',
    marginLeft: '2em',
    marginRight: '2em',
    marginBottom: '1em',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  titleText: {
    alignSelf: 'stretch',
    color: 'white',
    fontSize: '2em',
    textAlign: 'center',
  },
  imageName: {
    marginTop: '1em',
    marginLeft: '2em',
    marginRight: '2em',
    padding: '1em',
    alignSelf: 'stretch',
    backgroundColor: 'rgba(255,255,255,0.1)',
    borderRadius: '0.3em',

    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  image: {
    width: '7em',
    height: '7em',
    borderRadius: '0.3em',
  },
  nameText: {
    marginLeft: '1em',
    flex: 1,
    color: 'white',
    fontSize: '1em',
  },
  price: {
    marginTop: '1em',
  },
  deliveryText: {
    marginTop: '3em',
    marginLeft: '1em',
    alignSelf: 'stretch',
    color: 'white',
    fontSize: '1em',
  },
  input: {
    marginTop: '1em',
    backgroundColor: '#333',
    width: '28em',
    height: '3.5em',
    paddingLeft: '1em',
    paddingRight: '1em',
    marginBottom: '1em',
    borderRadius: '0.5em',
    color: 'white',
    fontSize: '1em',
    fontFamily: 'monospace',
  },
  purchaseButton: {
    marginTop: '2em',
    marginBottom: '5em',
  },
});

type Props = {
  style?: any;
  prize: Prize;
  onDone: () => void;
};
type State = {
  shipping_email: string;
  shipping_addr_1: string;
  shipping_addr_2: string;
  shipping_city: string;
  shipping_state: string;
  shipping_zip: string;
  shipping_phone: string;
};

export default class CheckoutOverlay extends BusyComponent<Props, State> {
  state = {
    shipping_email: '',
    shipping_addr_1: '',
    shipping_addr_2: '',
    shipping_city: '',
    shipping_state: '',
    shipping_zip: '',
    shipping_phone: '',
  };
  idempotent_key = uuidv4();

  _onPurchasePress = () => {
    const { store_delivery, recipe_id } = this.props.prize;

    const item_client_data = _getClientData(store_delivery, this.state);
    if (!item_client_data) {
      ModalDialog.error('Please complete all fields to ensure delivery.');
    } else if (this.setBusy()) {
      const opts = {
        idempotent_key: this.idempotent_key,
        recipe_id,
        item_client_data,
      };
      ItemStore.runRecipe(opts, err => {
        this.clearBusy();
        if (err === 'limit') {
          ModalDialog.error("Sorry, you can't purcahse anymore.");
        } else if (err) {
          ModalDialog.error('Failed to place order, please try again.');
        } else {
          ModalDialog.error('Order placed!');
          this.props.onDone();
        }
      });
    }
  };

  render() {
    const { style, prize, onDone } = this.props;
    const { display_name, image_url, coin_price, store_delivery } = prize;

    let extra_inputs = null;
    if (store_delivery === 'mail') {
      extra_inputs = (
        <>
          <TextInput
            style={styles.input}
            placeholder='name'
            autoCompleteType='off'
            autoCapitalize='none'
            autoCorrect={false}
            onChangeText={shipping_name => this.setState({ shipping_name })}
            value={this.state.shipping_name}
          />
          <TextInput
            style={styles.input}
            placeholder='address line 1'
            autoCompleteType='off'
            autoCapitalize='none'
            autoCorrect={false}
            onChangeText={shipping_addr_1 => this.setState({ shipping_addr_1 })}
            value={this.state.shipping_addr_1}
          />
          <TextInput
            style={styles.input}
            placeholder='address line 2'
            autoCompleteType='off'
            autoCapitalize='none'
            autoCorrect={false}
            onChangeText={shipping_addr_2 => this.setState({ shipping_addr_2 })}
            value={this.state.shipping_addr_2}
          />
          <TextInput
            style={styles.input}
            placeholder='city'
            autoCompleteType='off'
            autoCapitalize='none'
            autoCorrect={false}
            onChangeText={shipping_city => this.setState({ shipping_city })}
            value={this.state.shipping_city}
          />
          <TextInput
            style={styles.input}
            placeholder='state'
            autoCompleteType='off'
            autoCapitalize='none'
            autoCorrect={false}
            onChangeText={shipping_state => this.setState({ shipping_state })}
            value={this.state.shipping_state}
          />
          <TextInput
            style={styles.input}
            placeholder='zip'
            autoCompleteType='off'
            autoCapitalize='none'
            autoCorrect={false}
            onChangeText={shipping_zip => this.setState({ shipping_zip })}
            value={this.state.shipping_zip}
          />
        </>
      );
    } else if (store_delivery === 'phone') {
      extra_inputs = (
        <>
          <TextInput
            style={styles.input}
            placeholder='phone number'
            autoCompleteType='off'
            autoCapitalize='none'
            autoCorrect={false}
            onChangeText={shipping_phone => this.setState({ shipping_phone })}
            value={this.state.shipping_phone}
          />
        </>
      );
    }
    return (
      <View style={[styles.checkoutOverlay, style]}>
        <ScrollView
          style={styles.scroller}
          contentContainerStyle={styles.scrollInner}
        >
          <View style={styles.titleWrapper}>
            <Text style={styles.titleText}>Checkout</Text>
          </View>
          <View style={styles.imageName}>
            <Image style={styles.image} source={image_url} />
            <Text style={styles.nameText}>{display_name}</Text>
          </View>
          <CoinPrice
            style={styles.price}
            size='small'
            animated={true}
            price={coin_price}
          />
          <Text style={styles.deliveryText}>Delivery Details</Text>
          <TextInput
            style={styles.input}
            placeholder='email'
            autoCompleteType='off'
            autoCapitalize='none'
            autoCorrect={false}
            onChangeText={shipping_email => this.setState({ shipping_email })}
            value={this.state.shipping_email}
          />
          {extra_inputs}
          <WideButton
            style={styles.purchaseButton}
            text='Confirm'
            onPress={this._onPurchasePress}
          />
        </ScrollView>
        <CloseButton style={styles.close} onPress={onDone} />
      </View>
    );
  }
}

function _getClientData(store_delivery, state) {
  const {
    shipping_email,
    shipping_addr_1,
    shipping_addr_2,
    shipping_city,
    shipping_state,
    shipping_zip,
    shipping_phone,
  } = state;

  let ret = null;

  if (store_delivery === 'mail') {
    if (
      shipping_email &&
      shipping_addr_1 &&
      shipping_city &&
      shipping_state &&
      shipping_zip
    ) {
      ret = {
        shipping_email,
        shipping_addr_1,
        shipping_addr_2,
        shipping_city,
        shipping_state,
        shipping_zip,
      };
    }
  } else if (store_delivery === 'phone') {
    if (shipping_email && shipping_phone) {
      ret = {
        shipping_email,
        shipping_phone,
      };
    }
  } else {
    if (shipping_email) {
      ret = { shipping_email };
    }
  }

  return ret;
}
